import { defineStore } from "pinia";

export const useDarkMode = defineStore("darkMode", {
    state: () => {
        const savedMode = localStorage.getItem("darkMode") || "dark";
        return {
            darkMode: savedMode,
            isDark: savedMode === "dark",
        };
    },
    actions: {
        toggleMode() {
            this.darkMode = this.darkMode === "dark" ? "light" : "dark";
            this.isDark = this.darkMode === "dark";
            localStorage.setItem("darkMode", this.darkMode);
        },
        setMode(mode) {
            this.darkMode = mode === "dark" ? "dark" : "light";
            this.isDark = this.darkMode === "dark";
            localStorage.setItem("darkMode", this.darkMode);
        },
    },
});
